module.exports = __webpack_public_path__ + "img/filter.a7a13fb5.svg";